/* eslint-disable prettier/prettier */

export const QUERY = {
  allCountries: `
  query MyQuery {
    allMasterCountries(condition: {isActive: true}) {
      nodes {
        id
        value:id
        countryName
        label:countryName
        createdBy
        updatedAt
      }
    }
  }
    `,
  addCountry: ({ countryName }) => `
    mutation MyMutation {
      createMasterCountry(
        input: {
          masterCountry: {
            countryName: "${countryName}"
            isActive: true
            createdAt: "${new Date().toISOString()}"
            updatedAt: "${new Date().toISOString()}"
          }
        }
      ){
        clientMutationId
      }
    }
    `,
  updateCountry: ({ id, isActive = true, countryname }) => `
    mutation MyMutation {
      updateMasterCountryById(
        input: {
          masterCountryPatch: {
            ${countryname ? `countryname: "${countryname}"` : ``}
            isActive: ${isActive}
            updatedAt: "${new Date().toISOString()}"
          }
          id: "${id}"
        }
      ) {
        clientMutationId
      }
    }
    
    `
};